<template>
    <Teleport to="body">
        <div class="backdrop" v-if="isModalVisible" @click.prevent="closeModal"></div>
        <div class="modal" :class="{loading: isLoading, [currentModalId]: currentModalId}" v-if="currentModalVisible">
            <component :is="currentModalComponent" @close="closeModal" :trigger="modalTrigger" :params="modalParams"/>

            <div class="closeButton" @click.prevent="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <g clip-path="url(#clip0_3073_824)">
                        <path d="M11 1L1 11" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1 1L11 11" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_3073_824">
                            <rect width="12" height="12" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>

        </div>
    </Teleport>
</template>

<script setup>
import * as functions from '@/assets/js/Functions'
import { ref, onMounted, computed } from 'vue'
import bus from '@/store/EventBus.js';

import VisitOffer from './modals/VisitOffer.vue'
import DeleteLead from './modals/DeleteLead.vue'
import AddReview from './modals/AddReview.vue'

const modals = [
    { id: 'VisitOffer', component: VisitOffer },
    { id: 'DeleteLead', component: DeleteLead },
    { id: 'AddReview', component: AddReview }
]

const isModalVisible = ref(false)
const currentModalId = ref(null)
const modalTrigger = ref(null)
const modalParams = ref(null)

const currentModalComponent = computed(() => {
    const modal = modals.find((modal) => modal.id === currentModalId.value);
    return modal ? modal.component : null
});

const currentModalVisible = computed(() => isModalVisible.value && currentModalId.value !== null);

const showModal = (modalId, params = null, trigger = null) => {
    currentModalId.value = modalId
    isModalVisible.value = true
    modalTrigger.value = trigger
    modalParams.value = params
    document.body.style.overflow = 'hidden'
};

const closeModal = () => {
    isModalVisible.value = false
    currentModalId.value = null
    document.body.style.overflow = '' // Восстановление прокрутки страницы
};

bus.on('showModal', ({ modalId, params }) => {
    showModal(modalId, params);
})

onMounted(() => {
    functions.addEventListener('click', '[data-modal]', (e) => {
        e.preventDefault();
        const modalId = functions.attr(e.target, 'data-modal');
        showModal(modalId, {}, e.target);
    });
});
</script>

<style>
.backdrop {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(79, 79, 79, 0.60);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9998;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    width: 467px;
    max-width: 100%;
    padding: 50px 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: #FFF;
    z-index: 9999;
    animation: modalShow 350ms ease forwards;
    height: auto;
}
.modal.AddReview{
    width: 668px;
}
.modal .title{
    color: #333;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}
.modal .title span{
    color: var(--color-primary);
}
.modal .text{
    color: #333;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    margin: 14px 0;
}
.modal .buttons{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 30px 0 0;
    gap: 10px;
}
.modal .buttons .button{
    border-radius: 6px;
    border: 1px solid #BDBDBD;
    background: #FFF;
    padding: 10px;
    color: #333;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    flex: 1 1 0;
    text-decoration: none;
    transition: background-color 100ms ease-in-out, border-color 100ms ease-in-out;
    cursor: pointer;
}
.modal .buttons .button:hover{
    background: var(--color-primary-hover);
    border-color: var(--color-primary-hover);
    color: #fff;
}
.modal .buttons .mainButton{
    background: var(--color-primary);
    box-shadow: 0 6px 10px 0 rgba(62, 191, 31, 0.22);
    color: #fff;
}
.modal img {
    width: 80px;
    height: 80px;
    margin: 0 auto 30px;
    display: block;
    position: relative;
}
.modal .closeButton{
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
}
.modal .closeButton svg{
    width: 12px;
    height: 12px;
}
.iconModal{
    display: flex;
    flex-direction: row;
}
.iconModal .icon{
    width: 35px;
    text-align: left;
}
.iconModal .icon svg{
    width: 23px;
    height: auto;
}
.iconModal .data{
    text-align: left;
}
.iconModal .data .title{
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 14px;
    text-align: left;
}
.iconModal .data .text{
    font-weight: 500;
    font-size: 12px;
    line-height: 1.3;
    margin: 0;
    text-align: left;
}
@keyframes modalShow {
    from {
        opacity: 0;
        transform: translateY(calc(-50% + 30px)) translateX(-50%);
    }
    to {
        opacity: 1;
        transform: translateY(-50%) translateX(-50%);
    }
}
@media all and (max-width: 768px){
    .modal {
        max-width: calc(100% - 60px);
        padding: 40px 20px;
    }
}

</style>
